<template>
  <div>
    <card style="margin-top:20px">
      <form>
        <div class="row" style="margin-top:20px;margin-bottom:15px;margin-right:40px;margin-left:40px">
          <div class="col">
            <label for="data" style="font-weight:bold;margin-bottom:10px">Data<span style="color:#ff0000">*</span></label>
            <input type="date" class="form-control" id="data" v-model="data" placeholder="data" readonly>
          </div>
          <div class="col">
            <label for="id_tipologia" style="font-weight:bold;margin-bottom:10px">Id tipologia<span style="color:#ff0000">*</span></label>
              <select id="id_tipologia" v-model="id_tipologia" class="form-control" readonly>
                <option value="3">Bonus 50%</option>
                <option value="2">Bonus 90%</option>
                <option value="1">Bonus 110%</option>
              </select>
          </div>
        </div>
        <div class="row" style="margin-top:20px;margin-bottom:15px;margin-right:40px;margin-left:40px">
          <div class="col align-self-center">
            <label for="denominazione" style="font-weight:bold;margin-bottom:10px">Denominazione<span style="color:#ff0000">*</span></label>
            <input type="text" class="form-control" id="denominazione" v-model="denominazione" placeholder="denominazione" readonly>
          </div>
        </div>
        <div class="row" style="margin-bottom:15px;margin-right:40px;margin-left:40px">
          <div class="col align-self-center">
            <label for="codice_fiscale" style="font-weight:bold;margin-bottom:10px">Codice Fiscale<span style="color:#ff0000">*</span></label>
            <input type="text" class="form-control" id="codice_fiscale" v-model="codice_fiscale" placeholder="codice_fiscale" readonly>
          </div>
        </div>
        <!-- <div class="row"> -->
        <button type="button" class="btn float-center" style="background:#00467f;" v-on:click="salvaValori()">Salva</button>
        <!-- </div> -->
        <h3>Carica documenti</h3>
        <div class="form-row"  v-for="valori in documentiDaCaricare.ASS_DOCUMENTO_TIPOs" v-bind:key="valori.ID">
          <div class="form-group justify-content-start" style="text-align:left">
              <h4>{{valori.NOME}}</h4>
              <p v-if="valori.DESCRIZIONE!=''">{{valori.DESCRIZIONE}}</p>
              <button class="btn float-left" style="font-size:12px;background:#00467f">Scegli file<input class="form-control" type="file" multiple name="documento" ref="file" v-on:change="checkFileUpload()"></button>
              
            <!-- <table class="table tablesorter" id="tabella" style="text-align: center">
              <thead>
                <tr>
                  <th>NOME</th>
                  <th>DESCRIZIONE</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr class="row-color"  v-for="valori in documentiDaCaricare.ASS_DOCUMENTO_TIPOs" v-bind:key="valori.ID">
                  <td>{{valori.NOME}}</td>
                  <td>{{valori.DESCRIZIONE}}</td>
                  <td>
                    <button class="btn" style="margin-left:10px;font-size:12px;background:#00467f">Scegli file<input class="form-control" type="file" multiple name="documento" ref="file" v-on:change="checkFileUpload()"></button>
                  </td>
                </tr>
              </tbody>
            </table> -->
          </div>
        </div>
      </form>
      <!-- <div class="row">
        <div class="col" style="text-align:center">
          <h3 style="text-align:center;margin-top:20px">BONUS {{bonus}} %</h3>
          <p style="margin-top:10px;font-size:24px">ANTIRICICLAGGIO</p>
          <button class="btn">Premi qui per una richiesta</button>
          <p style="margin-top:10px;font-size:24px">CARICA DOCUMENTO 1</p>
          <button class="btn">Carica doc 1</button>
          <p style="margin-top:10px;font-size:24px">CARICA DOCUEMNTO 2</p>
          <button class="btn">Carica doc 2</button>
        </div>
      </div> -->
      <router-link to="/asseverazioni" class="btn float-left" style="margin-right:50px;background:#00467f">Indietro</router-link>
    </card>
    <!--  MODAL CARICARE FILE -->
    <b-modal v-model="showCheckFile" size="md">
      <template #modal-header="{ close }">
        <b-button size="sm" style="background:#00467f;" @click="close()">X</b-button>
      </template>
      <template>
        <h3 style="color:black; text-align:center; margin-top:15px">Sicuro di voler caricare il documento?</h3>
        <div class="container">
          <div id="preloader_3" v-if="showLoader"></div>
        </div>
      </template>
      <template #modal-footer="{ cancel }">
        <span  v-if="!showLoader" style="padding-left:40px;"><b-button size="sm" variant="danger" @click="cancel()">NO</b-button></span>
        <span  v-if="!showLoader" style="padding-right:40px;"><b-button size="sm"  style="background:#00467f;" @click="handleFileUpload()">SI</b-button></span>
      </template>
    </b-modal>
  </div>
</template>
<script>
import Card from '../../components/Cards/Card.vue';
import Services from '@/services/Services';
import AsseverazioniServices from '@/services/AsseverazioniServices';
import axios from 'axios';

export default {
  components: {
    Card
      
  },
  /**
   * Chart data used to render stats, charts. Should be replaced with server data
   */
  data() {
    return {
        show50: false,
        show90: false,
        show110: false,
        show: false,
        bonus: null,

        // carica file
        showCheckFile: false,
        showLoader: false,
        file: null,

        codice_fiscale: null,
        denominazione:null,
        dati: [],
        asseverazione: [],
        fileCaricati: [],

        documentiDaCaricare: [
          // {"ID":1,"NOME":"Documento di riconoscimento del contribuente cedente il credito","DESCRIZIONE":"","createdAt":"2022-02-20T22:26:03.000Z","updatedAt":"2022-02-20T22:26:03.000Z","ASS_ASS_TIPO_DOC_TIPO":{"createdAt":"2022-02-20T22:31:10.000Z","updatedAt":"2022-02-20T22:31:10.000Z","ID_ASSEVERAZIONE_TIPO":1,"ID_DOCUMENTO_TIPO":1}},
          // {"ID":1,"NOME":"Documento di riconoscimento del contribuente cedente il credito","DESCRIZIONE":"","createdAt":"2022-02-20T22:26:03.000Z","updatedAt":"2022-02-20T22:26:03.000Z","ASS_ASS_TIPO_DOC_TIPO":{"createdAt":"2022-02-20T22:31:10.000Z","updatedAt":"2022-02-20T22:31:10.000Z","ID_ASSEVERAZIONE_TIPO":1,"ID_DOCUMENTO_TIPO":1}},
          // {"ID":1,"NOME":"Documento di riconoscimento del contribuente cedente il credito","DESCRIZIONE":"","createdAt":"2022-02-20T22:26:03.000Z","updatedAt":"2022-02-20T22:26:03.000Z","ASS_ASS_TIPO_DOC_TIPO":{"createdAt":"2022-02-20T22:31:10.000Z","updatedAt":"2022-02-20T22:31:10.000Z","ID_ASSEVERAZIONE_TIPO":1,"ID_DOCUMENTO_TIPO":1}}
        ],

        idAsseverazione: null,
        idBonus: null,
        access_token: null,
        token_response: [],
        user_livello: null,
        urlRichieste: 'https://sviluppoallergeni.confcom.it/'
    };
  },
  methods: {
    caricaPagina: async function() {
      let errore = 0;
        this.codice_fiscale= '...';
        this.denominazione = '...';
        await AsseverazioniServices.getDocumenti(this.idBonus)
        .then(response => { this.documentiDaCaricare = response.data})
        .catch(function (error) {
          // handle error
          if(error.response.status == 403){
            errore = error.response.status;
          } else if (error.response.status == 401) {
            errore = error.response.status;
          }
        });
        if (errore == 401) {
          let value = await Services.refreshTokenFunction();//await this.refreshToken();
          if (value) { await this.caricaPagina(); }
        }
        console.log(`doc da caricare`)
        console.log(this.documentiDaCaricare);

        await AsseverazioniServices.getAsseverazione(this.idAsseverazione)
        .then(response => { this.dati = response.data})
        .catch(function (error) {
            // handle error
            if(error.response.status == 403){
              errore = error.response.status;
            } else if (error.response.status == 401) {
              errore = error.response.status;
            }
        });
        if (errore == 401) {
          let value = await Services.refreshTokenFunction();//await this.refreshToken();
          if (value) { await this.caricaPagina(); }
        }
        // this.documentiDaCaricare = this.documentiDaCaricare.ASS_DOCUMENTO_TIPOs
        console.log(`dati`);
        console.log(this.dati);

    },

    checkFileUpload: function() {
      this.showCheckFile = true;
    },

    handleFileUpload: async function(){
      this.showLoader = true;
      let token = localStorage.getItem('access_token');
      let risposta;
      let errore = 0;
      this.file = this.$refs.file.files[0];
      let formData = new FormData()
      formData.append('documento', this.file)
      let data = [];
      data.push({ID_DOCUMENTO_TIPO: this.idBonus});
      formData.append('data', data); //JSON
      // POST /asseverazione/documento/:idasseverazione
      await axios.post(
          this.urlRichieste + 'asseverazione/documento/' + this.idAsseverazione,
          formData,
              {
              withCredentials: true,
              headers: {
              'Content-type': 'multipart/form-data',
              'Authorization': `Bearer ${token}`
              }
          }
      )
      .then(response => { this.fileCaricati = response.data})
      .catch( function (error) {
      // handle error
      if(error.response.status == 401){
          errore = error.response.status;
      }
      })
      if (errore == 401) {
          console.log(`errore 401`);
          let value = await Services.refreshTokenFunction(); //await this.refreshToken();
          if (value) { await this.handleFileUpload(); }
      }
      this.showCheckFile = false;
      this.showLoader = false;
      console.log(this.fileCaricati);
      // await this.getFileCaricati();
  },

    main: async function() {
       this.user_livello = localStorage.getItem('user_livello');
        this.idBonus = this.$route.query.idBonus;
        this.idAsseverazione = this.$route.query.idAsseverazione;
        // thus.idDoc = this.$route.query.idDoc;
        this.access_token = localStorage.getItem('access_token');
        axios.defaults.withCredentials = true;
        try {
            this.caricaPagina();
            // if (this.id != null ) {
            //     await this.caricaPagina();
            // }
        } catch (error) {
            if (error.response.status == 401) {
                await Services.refreshTokenFunction();
            }
        }
    },
    
  },
  mounted() {
      this.main();
    }
};
</script>
<style scoped>
    label {
        font-size: 16px;
    } 
    h3 {
        color:black;
        text-align: left;
    }
  .rectangle {
    height: 180px;
    /* width: 10px; */
    display: inline;
    margin-right: 70px;
    margin-left: 70px;
    margin-top: 20px;
    float: left;
    border-style: solid;
    border-color: #00467f;
    border-width: 5px;
    line-height: 200px;
    cursor: pointer;
  }

  .box-text {
    display: inline-block;
    text-align: center;
    line-height: normal;
    vertical-align: middle;
    font-weight: bold;
    color: #00467f;
  }
</style>
